var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.00002H17.4054C19.901 8.00002 21.7873 10.2602 21.3408 12.7156L20.4318 17.7156C20.0859 19.6175 18.4294 21 16.4963 21H8V9L9.82111 3.21218C10.1165 2.52285 10.8814 1.89557 11.8446 2.08106C13.3737 2.37554 15 3.56734 15 5.50004V8.00002ZM6 9C4.34315 9 3 10.3431 3 12V18C3 19.6569 4.34315 21 6 21V9Z",
    fill: "#008485"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDark);
export default __webpack_public_path__ + "static/media/likeDark.a8ef4da79ee39dcf52aa2a3f5fa035f2.svg";
export { ForwardRef as ReactComponent };